import { render, staticRenderFns } from "./NoOffers.vue?vue&type=template&id=10b9d4f3&scoped=true"
import script from "./NoOffers.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoOffers.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NoOffers.vue?vue&type=style&index=0&id=10b9d4f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9d4f3",
  null
  
)

export default component.exports